module.exports = __webpack_public_path__ + "img/Yanlei_Diao.abffc160.png";